import React from 'react';
import axios from "axios";
import {concepts, Group, User, GroupRole} from "fearless-common";
import {backendEndpoints} from "../../libs/backendEndpoints";
import InviteUserModal from "./InviteUserModal";
import BackendForm from "../forms/BackendForm";
import {useFormikContext} from "formik";
import DynamicList from "../forms/DynamicList";
import UserRow from "./UserRow";
import {useConfirm} from "../contexts/ConfirmationModalContext";


/**
 * Wrapper to access the formik context.
 */
function DynamicListWrapper({ groupId, reloadGroup, groupRole, groupIsSubscribed, readOnly }: {
    groupId: number;
    reloadGroup: () => void;
    readOnly: boolean;
    groupIsSubscribed: boolean;
    groupRole: GroupRole | null;
}) {
    const { submitForm, values } = useFormikContext<{ users: User[] }>();
    const { openPromisify } = useConfirm();

    const inviteUserButton = readOnly === false ? (
        <InviteUserModal
            groupId={groupId}
            reloadGroup={reloadGroup}
            groupIsSubscribed={groupIsSubscribed}
        />
    ) : null;
    return (
        <>
            <DynamicList
                name="users"
                headers={[
                    { label: <span className="me-1">{concepts.GroupMembers} ({values.users?.length})</span>, size: 3, sortable: 'first_name', labelAfterSort: <span className="ms-1">{inviteUserButton}</span> },
                    { label: <>{concepts.Subscription}</>, size: 3 },
                    { label: <>Role</>, size: 3 },
                    { label: <>&nbsp;</>, size: 3, className: "text-end" },
                ]}
                Component={(props) => (
                    <UserRow
                        {...props}
                        groupId={groupId}
                        groupRole={groupRole}
                        readOnly={readOnly}
                        onChange={() => submitForm()}
                        reload={reloadGroup}
                    />
                )}
                onDelete={(user: User) => {
                    return openPromisify(
                        'Are you sure you want to remove '+(user.first_name || user.email)+' from the '+concepts.Group.toLowerCase()+'?',
                        () =>  axios.delete(`/groups/${groupId}/remove-user`, { data: { user_id: user.id } })
                            .then(() => reloadGroup()),
                        true,
                    )
                }}
            />
        </>
    );
}

export default function GroupUserManagement({ group, reload, onSuccess, readOnly = false }: {
    group: Group;
    reload: () => void;
    onSuccess: () => void;
    readOnly?: boolean;
}) {
    const groupId = group.id;

    return (
        <BackendForm
            initialValues={group}
            targetEndpoint={`${backendEndpoints.updateGroup(group.id)}?_with[]=users`}
            targetMethod="PUT"
            enableReinitialize={!readOnly}
            showFooter={false}
            onSuccess={onSuccess}
        >
            <BackendForm.Feedback showError />
            <DynamicListWrapper
                groupId={groupId}
                groupRole={group?.role || null}
                reloadGroup={reload}
                readOnly={readOnly}
                groupIsSubscribed={group?.is_subscribed}
            />
        </BackendForm>
    );
}
